export class AddOrUpdateLimitResponseModel {
    constructor(public message: string) {}
}
